import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { cadastrarGerente } from '../../services/api';
// css
import 'bootstrap/dist/css/bootstrap.min.css';
import "./FormCadastrarGerente.css";
import '../../styles/global.css';


const FormCadastrarGerente = () => {
  
  const navigate = useNavigate();  // Hook para navegação

  const [formData, setFormData] = useState({
    nomeCompleto: "",
    email: "",
    password: "",
    confirmPassword: "",
    cpf: "",
    telefoneCelular: "",
    nomeEstabelecimento: "",
    telefoneFixoEstabelecimento: "",
    telefoneCelularEstabelecimento: "",
    endereco: "",
    uf: "",
    cidade: "",
    descricaoEstabelecimento: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    console.log('entrou no handleSubmit...');
    e.preventDefault();
    try {
      const response = await cadastrarGerente(formData);
      console.log('Gerente cadastrado com sucesso:', response);
      alert('Gerente cadastrado com sucesso!');
      navigate('/area-restrita');
    } catch (error) {
      console.error('Erro ao cadastrar gerente:', error);
      // Exibe a mensagem de erro vinda da API
      const errorMessage = error.response?.data?.message || 'Erro ao cadastrar gerente. Tente novamente.';
      alert(errorMessage);
    }
  };
  


  return (
    <div className="form-cadastrar-container">
        <TituloComponent />

      <form onSubmit={handleSubmit}>
        <h2 className="form-title">Cadastro de Gerente</h2>

        {/* Quadro de Dados Pessoais */}
        <div className="form-section">
          <h3 className="section-title">Dados Pessoais</h3>
          
          <div className="form-group">
            <label htmlFor="nomeCompleto">Nome completo</label>
            <input
              type="text"
              id="nomeCompleto"
              name="nomeCompleto"
              className="form-control"
              placeholder="Digite o nome completo"
              value={formData.nomeCompleto}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="telefoneCelular">Telefone Celular com DDD</label>
            <input
              type="tel"
              id="telefoneCelular"
              name="telefoneCelular"
              className="form-control"
              placeholder="Digite o telefone celular"
              value={formData.telefoneCelular}
              onChange={handleChange}
              required
            />
          </div>          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control"
              placeholder="Digite o email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="cpf">CPF</label>
            <input
                type="tel" // Altera para 'tel' para exibir teclado numérico
                id="cpf"
                name="cpf"
                className="form-control"
                placeholder="Digite o CPF"
                value={formData.cpf}
                onChange={handleChange}
                pattern="\d*" // Permite apenas dígitos
                maxLength="11" // Limita o número de caracteres a 11 (tamanho de um CPF sem formatação)
                required
            />
            </div>

          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                placeholder="Digite sua senha"
                value={formData.password}
                onChange={handleChange}
                required
            />
          </div>  

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirme sua senha</label>
            <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                className="form-control"
                placeholder="Repita sua senha"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
            />
          </div>
        </div>

        {/* Quadro de Dados do Estabelecimento */}
        <div className="form-section business-data">
          <h3 className="section-title">Dados do Estabelecimento</h3>
          <div className="form-group">
            <label htmlFor="nomeEstabelecimento">Nome do Estabelecimento</label>
            <input
              type="text"
              id="nomeEstabelecimento"
              name="nomeEstabelecimento"
              className="form-control"
              placeholder="Digite o nome do estabelecimento"
              value={formData.nomeEstabelecimento}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="telefoneFixoEstabelecimento">Telefone fixo do Estabelecimento com DDD</label>
            <input
              type="tel"
              id="telefoneFixoEstabelecimento"
              name="telefoneFixoEstabelecimento"
              className="form-control"
              placeholder="Digite o telefone com o DDD"
              value={formData.telefoneFixoEstabelecimento}
              onChange={handleChange}
              required
            />
          </div>          

          <div className="form-group">
            <label htmlFor="telefoneCelularEstabelecimento">Telefone celular do Estabelecimento com DDD</label>
            <input
              type="tel"
              id="telefoneCelularEstabelecimento"
              name="telefoneCelularEstabelecimento"
              className="form-control"
              placeholder="Digite o telefone com o DDD"
              value={formData.telefoneCelularEstabelecimento}
              onChange={handleChange}
              required
            />
          </div>          

          <div className="form-group">
            <label htmlFor="endereco">Endereço completo</label>
            <input
              type="text"
              id="endereco"
              name="endereco"
              className="form-control"
              placeholder="Digite o endereço completo"
              value={formData.endereco}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="uf">UF</label>
            <select
              id="uf"
              name="uf"
              className="form-control"
              value={formData.uf}
              onChange={handleChange}
              required
            >
              <option value="">Selecione o estado</option>
              {[
                "AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB",
                "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO",
              ].map((estado) => (
                <option key={estado} value={estado}>
                  {estado}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="cidade">Cidade</label>
            <input
              type="text"
              id="cidade"
              name="cidade"
              className="form-control"
              placeholder="Digite a cidade"
              value={formData.cidade}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="descricaoEstabelecimento">Descrição do Estabelecimento</label>
            <textarea
              id="descricaoEstabelecimento"
              name="descricaoEstabelecimento"
              className="form-control"
              placeholder="Digite a descrição do estabelecimento"
              rows="4"
              value={formData.descricaoEstabelecimento}
              onChange={handleChange}
              required
            ></textarea>
          </div>
        </div>

        <button type="submit" className="btn-primary">
          Cadastrar
        </button>
      </form>
    </div>
  );
};

export default FormCadastrarGerente;
